<div class="hit-list-dropdown-container">
    <p-select
        aria-label="Sortieren"
        class="hit-list-dropdown"
        appendTo="body"
        [options]="sortingByValues"
        [ngModel]="selectedSortingBy"
        optionLabel="label"
        (ngModelChange)="sortingByChanged($event)"
    ></p-select>
    <p-selectButton
        class="hit-list-select"
        [options]="sortingOrderValues"
        [allowEmpty]="false"
        [ngModel]="selectedSortingOrder"
        (ngModelChange)="sortingOrderChanged($event)"
    >
        <ng-template let-item pTemplate="item">
            <i [class]="item.icon" [attr.aria-label]="item.ariaLabel"></i>
        </ng-template>
    </p-selectButton>
</div>
